module.exports = __webpack_public_path__ + "static/908-d0dfe0ca44acf3f04a52839cab5a5512.png";